var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCarretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.145 9.347a.563.563 0 01-.122.613l-5.625 5.625a.562.562 0 01-.796 0L2.977 9.96A.563.563 0 013.375 9h4.267L2.977 4.335a.563.563 0 01.398-.96h11.25a.562.562 0 01.398.96L10.358 9h4.267a.562.562 0 01.52.347z",
    fill: "#0D814A"
  })));
}
export default SvgGreenCarretDown;